import './hero.component.scss';
import { Component } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwHero
 * @module mw.components.hero
 *
 * @description
 * `<mw-hero>` is a component used to display a big title with a custom md-menu
 *
 * @usage
 * <hljs hljs-language="html">
 *     <mw-hero>
 *          <span translate>I am looking for</span>
 *          <md-menu class="mw-menu" md-position-mode="target-left target" md-offset="0 40">
 *              <mw-menu-trigger-button tooltip="{{'Open Menu' | translate}}" on-click="$mdOpenMenu($event)" dropdown-icon="hardware:ic_keyboard_arrow_down_24px">{{$ctrl.selected | translate}}</mw-menu-trigger-button>
 *              <md-menu-content class="mw-menu-dropdown" md-padding="md-padding">
 *                  <mw-menu-item type="focusdummy" md-autofocus></mw-menu-item>
 *                  <mw-menu-item type="singleselect" is-selected="$ctrl.selected === item" on-click="$ctrl.onSelect(item)" ng-repeat="item in $ctrl.items">{{item | translate}}</mw-menu-item>
 *              </md-menu-content>
 *          </md-menu>
 *      </mw-hero>
 * </hljs>
 *
 */

@Component({
    selector: 'mw-hero',
    template: `
        <div class="mw-hero__container" ng-transclude></div>
    `,
    legacy: {
        transclude: true
    }
})
export class HeroComponent {

}


// WEBPACK FOOTER //
// ./src/lib/components/hero/hero.component.ts